import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";

import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { BaseModel, QuoteModel } from "@insite/client-framework/Types/ApiModels";
import { createQuote, CustomCreateQuoteApiParameter } from "@ucs/Services/UcsQuoteService";

type HandlerType = ApiHandlerDiscreteParameter<
    HasOnSuccess<QuoteModel> & HasOnError<string>,
    CustomCreateQuoteApiParameter,
    QuoteModel
>;


export const PopulateApiParameter: HandlerType = props => {
    const quoteParameter = props.getState().pages.rfqRequestQuote.quoteParameter;
    // const { quoteId, jobName, quoteType, accountId, note } = quoteParameter;
    const state = props.getState() as any;

    const apiQuoteParameter = {
        quoteId: quoteParameter.quoteId,
        jobName: quoteParameter.jobName,
        isJobQuote: quoteParameter.quoteType === "job",
        userId: quoteParameter.accountId,
        note: quoteParameter.note,
    }
    
    let requestShipDateForQuote = state.customReducer.requestShipDateForQuote;
    if(!requestShipDateForQuote)
        {requestShipDateForQuote = "";}
    
    props.apiParameter = {
        quoteParameter: apiQuoteParameter,
        properties: { shipDate: requestShipDateForQuote},
    };
};

export const CreateOrRequestQuote: HandlerType = async props => {
    const { parameter, apiParameter } = props;
    const result = await createQuote(apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const DispatchQuotesReset: HandlerType = props => {
    props.dispatch({
        type: "Data/Quotes/Reset",
    });
};

export const LoadCart: HandlerType = props => {
    // the cart lines will be gone so we must reload
    props.dispatch(loadCurrentCart());
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    PopulateApiParameter,
    CreateOrRequestQuote,
    DispatchQuotesReset,
    LoadCart,
    ExecuteOnSuccessCallback,
];

const ucsCreateOrRequestQuote = createHandlerChainRunnerOptionalParameter(chain, {}, "UcsCreateOrRequestQuote");
export default ucsCreateOrRequestQuote;
